import React, { useEffect, useState, useRef } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { DateRangePicker } from 'react-date-range';
import { toast, ToastContainer } from 'react-toastify';
import Select from 'react-select';
import { MonthPicker } from '@mantine/dates';
import { format } from 'date-fns';
import "./overview.css"
import ApiCallServices from "../../../../services/ApiCallServices"
import { END_POINTS } from '../../../../services/endpoint/endPoint';
import AgencyPartnersDetail from './childs/AgencyPartnersDetail';
import DataListing from "./childs/DataListing"
import button from "../../../button.module.css"
import MultiselectCheckbox from '../../../common/multiselect-checkbox/MultiselectCheckbox';

const AgencyOverview = () => {
  let agencyName = localStorage.getItem("agencyName")
  let userCurrency = JSON.parse(localStorage.getItem("user"))

  let { agencyId } = useParams()
  const navigate = useNavigate();
  let user = JSON.parse(localStorage.getItem("user"))
  const currentDate = new Date();
  const firstDayOfMonth = new Date(currentDate.getFullYear(), currentDate.getMonth(), 1);
  const firstDayOfYear = new Date(new Date().getFullYear(), 0, 1);
  const [partnerInfo, setPartnerInfo] = useState([]);
  const [privillage, setPrivillage] = useState([])
  const [cardWidth, setCardWidth] = useState();
  const [partnerId, setPartnerId] = useState(0);
  const [tableData, setTableData] = useState([]);
  const [durationType, setDurationType] = useState('daily');
  const [currency, setCurrency] = useState(userCurrency?.currency  != "ALL"?userCurrency.currency  :"USD");
  const [toggleCalander, setToggleCalander] = useState(false);
  const [dateRange, setDateRange] = useState({
    startDate: firstDayOfMonth,
    endDate: currentDate,
    key: 'selection',
  });
  const [monthRange, setMonthRange] = useState([firstDayOfYear, currentDate]);
  const [applyDateRange, setApplyDateRange] = useState(dateRange);

  const [sortingColumn, setSortingColumn] = useState('');
  const [sortingOrder, setSortingOrder] = useState('dsc');

  const isCalanderShow = useRef(null);
  const calanderValue = useRef(null)

  const [graphData, setGraphData] = useState([])
  const [singleGraphList, setSingleGraphList] = useState([])

  const [loader, setLoader] = useState(false);

  const [showHideModal, setShowHideModal] = useState(false)
  const [partnerList, setPartnerList] = useState([])
  const [selectedPartner, setSelectedPartner] = useState(null)
  const [privilegeList, setPrivillageList] = useState([])
  const [selectedPrivilege, setSelectedPrivilege] = useState([])
  const [fileFormat, setFileFormat] = useState({ name: "CSV", id: "csv" });



  const handleMonthChange = (newRange) => {

    setMonthRange(newRange);

  };


  const getPartnerData = () => {
    const data = {
      startDateRange: `${format(applyDateRange.startDate, 'MM/dd/yyyy')}`,
      endDateRange: `${format(applyDateRange.endDate, 'MM/dd/yyyy')}`,
      agency_id: `${partnerId}`, currency: `${currency}`,
      agencyId: agencyId ? agencyId : null
    };

    ApiCallServices.create(END_POINTS.reportAgencyPartnerCardData, data).then((res) => {
      console.log(res, "res overview***")
      const data = res.data.data;
      if (res.status === 200) {
        setPartnerInfo(data.cardData);
        setPrivillage(data.privillage)
        if (data.cardData.length > 1 || data.cardData.length < 5) {
          const width = 96 / data.cardData.length;
          setCardWidth(width);
        }
      }
    })
      .catch((error) => {
        if (error.response) {
          toast.error(error.response.data.error, {
            position: "top-right"
          });
          console.log(error.response, "===>error in getting response");

        }
      });
  }

  const handleChildData = (partner_id) => {
    if (partner_id) {
      setPartnerId(partner_id);
    } else {
      setPartnerId(0);
    }
  }

  const getPartnerTableList = () => {
    setLoader(true)
    const data = {
      startDateRange: `${format(applyDateRange.startDate, 'MM/dd/yyyy')}`,
      endDateRange: `${format(applyDateRange.endDate, 'MM/dd/yyyy')}`,
      agency_id: `${partnerId}`,
      currency: `${currency}`,
      sortingcolumn: sortingColumn,
      sortingorder: sortingOrder,
      agencyId: agencyId ? agencyId : null
    };
    ApiCallServices.create(END_POINTS.reportAgencyPartnerList, data).then((res) => {
      console.log(res, "****66666")
      let resp = res.data.data;
      if (res.status === 200) {
        setTableData(resp);
        setLoader(false)
      }
    })
      .catch((error) => {
        if (error.response) {
          toast.error(error.response.data.error, {
            position: "top-right"
          });
          console.log(error.response, "===>error in getting response");

        }
      });
  }

  useEffect(() => {
    getPartnerTableList();
  }, [partnerId, applyDateRange, currency, sortingColumn, sortingOrder, agencyId]);

  useEffect(() => {
    getPartnerData();
  }, [applyDateRange, currency, agencyId]);

  const handleCurrency = (e) => {
    setCurrency(e.target.value);
  }

  const handleDurationType = (e) => {
    setDurationType(e.target.value);
  }

  const handleCalanderToggle = () => {
    setToggleCalander((prev) => !prev);
  }

  const handleDateChange = (ranges) => {
    setDateRange(ranges.selection);
  }
  const applyDateFilter = () => {
    if (durationType === 'monthly') {
      const startMonth = new Date(monthRange[0]); // First month selected
      const endMonth = monthRange[1] ? new Date(monthRange[1]) : startMonth; // Second month or duplicate first

      const startDate = new Date(startMonth.getFullYear(), startMonth.getMonth(), 1); // 1st of the start month
      const endDate = new Date(endMonth.getFullYear(), endMonth.getMonth() + 1, 0); // Last day of the end month

      setApplyDateRange({ startDate: startDate, endDate: endDate, key: 'selection' });

    } else {
      setApplyDateRange(dateRange);
    }
    // setApplyDateRange(dateRange);
    setToggleCalander(false);
  }


  const handleSort = (column) => {
    const order = sortingColumn === column && sortingOrder === 'asc' ? 'desc' : 'asc';
    setSortingColumn(column);
    setSortingOrder(order);
  }

  const handleClickOutSide = (e) => {
    if (isCalanderShow?.current && !isCalanderShow?.current.contains(e.target) && calanderValue?.current && !calanderValue?.current.contains(e.target)) {
      setToggleCalander(false)
    }
  }
  document.addEventListener('click', handleClickOutSide)

  const goBackOnAgencyOverview = () => {
    navigate("/agency-overview")
  }

  const getGraphData = () => {
    let data = {
      startDateRange: `${format(applyDateRange.startDate, 'MM/dd/yyyy')}`,
      endDateRange: `${format(applyDateRange.endDate, 'MM/dd/yyyy')}`,
      agencyId: agencyId ? agencyId : null, currency: `${currency}`,
      durationType: durationType
    }
    ApiCallServices.create(END_POINTS.reportAgencyPartnerGraph, data).then((res) => {
      let resp = res.data.data.data
      if (res.status == 200) {
        setGraphData(resp.cardData)
      }
    })
      .catch((error) => {
        if (error.response) {
          toast.error(error.response.data.error, {
            position: "top-right"
          });
          console.log(error.response, "===>error in getting response");

        }
      });
  }

  const SingleGraphData = (id) => {
    // setSingleGraphId(id);
    if (id && id !== undefined) {
      setPartnerId(id)
    }

    let data = {
      startDateRange: `${format(applyDateRange.startDate, 'MM/dd/yyyy')}`,
      endDateRange: `${format(applyDateRange.endDate, 'MM/dd/yyyy')}`,
      agency_id: id ? id : 0,
      agencyId: agencyId ? agencyId : null, currency: `${currency}`
    }
    ApiCallServices.create(END_POINTS.reportAgencyExpandedGraph, data).then((res) => {
      let resp = res.data.data.data
      if (res.status == 200) {
        setSingleGraphList(resp.tableData);
        if (id) {
          setPartnerId(id);
        }
      }
    })
      .catch((error) => {
        if (error.response) {
          toast.error(error.response.data.error, {
            position: "top-right"
          });
          console.log(error.response, "===>error in getting response");

        }
      });
  }

  useEffect(() => {
    getGraphData();
  }, [applyDateRange, agencyId, currency]);

  useEffect(() => {
    SingleGraphData();
  }, [applyDateRange, agencyId, currency]);


  const downloadCSV = async () => {
    const selectedColumns = selectedPrivilege?.map((item) => item.label);
    const startDateFormatted = format(applyDateRange.startDate, 'MM_dd_yyyy');
    const endDateFormatted = format(applyDateRange.endDate, 'MM_dd_yyyy');
    const fileExt = fileFormat?.id || "csv";
    const fileName = `agency_partner_report_${startDateFormatted}_to_${endDateFormatted}.${fileExt}`;
  
    const data = {
      startDateRange: `${format(applyDateRange.startDate, 'MM/dd/yyyy')}`,
      endDateRange: `${format(applyDateRange.endDate, 'MM/dd/yyyy')}`,
      agency_id: selectedPartner?.id || 0,
      agencyId: agencyId || null,
      currency: currency,
      columns: selectedColumns,
    };
  
    try {
      const response = await ApiCallServices.create(
        `${END_POINTS.reportAgencyPartnerList}?downloadCSV=true&fileformat=${fileExt}`,
        data,
        { responseType: 'blob' }
      );
  
      if (response.status === 200) {
        const mimeType =
          fileExt === "xlsx"
            ? "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            : "text/csv";
  
        const blob = new Blob([response.data], { type: mimeType });
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = fileName;
        document.body.appendChild(a);
        a.click();
        a.remove();
        window.URL.revokeObjectURL(url);
  
        setShowHideModal(false);
        setSelectedPrivilege(null);
        setSelectedPartner(null);
        document.body.removeAttribute("style");
      } else {
        toast.error("Failed to download report.");
      }
    } catch (error) {
      console.error("Download error:", error);
      toast.error("Something went wrong. Please try again.");
    }
  };
  
  const handleHideShowModal = () => {
    setShowHideModal(true)
    document.body.style = 'overflow: hidden'
  }

  const handleFormReset = () => {
    setShowHideModal(false)
    document?.body?.removeAttribute('style');

  }

  const getPartnerList = () => {
    ApiCallServices.getlisting(END_POINTS.csvAgencyPartner).then((res) => {
      if (res.status == 200) {
        setPartnerList(res.data.data);

      }
    })
      .catch((error) => {
        // Handle errors here
        if (error.response) {
          toast.error(error.response.data.error, {
            position: "top-right"
          });
          console.log(error.response, "===>error in getting response");
        }
      });
  }

  useEffect(() => {
    getPartnerList();
  }, [])

  const handleSelectChange = (selectedValue) => {
    setSelectedPartner(selectedValue);
  }

  const handlePrivilegeChange = (value) => {
    console.log(value, "multicheckmultichec")
    setSelectedPrivilege(value);
  }

  const getPrevilagesList = () => {
    let data = {
      userId: user?.id
    }
    ApiCallServices.create(END_POINTS.privilegeList, data).then((res) => {
      let resp = res.data.data;
      if (res.status === 200) {
        let resArr = []
        resp.privilege.split(',').map((item, i) => {
          return resArr.push({ value: i, label: item })
        })
        setPrivillageList(resArr)
      }
    })
      .catch((error) => {
        if (error.response) {
          toast.error(error.response.data.error, {
            position: "top-right"
          });
          console.log(error.response, "===>error in getting response");

        }
      });
  }
  useEffect(() => {
    getPrevilagesList();
  }, [])

  const customStyles = {
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isSelected ? '#fff' : state.isFocused ? '#6abfe94d' : undefined,
      color: state.isSelected ? '#000' : 'black',
      padding: 10,
      display: 'flex',
      alignItems: 'center',
    }),
  };

  return (
    <>
      <ToastContainer />
      <div className='container-fluid'>
        <div className='filter-wraper overview'>
          {agencyId && <h4 className='client-report-head'> Agency Report : {agencyName} <i class="fa-regular fa-circle-xmark" onClick={goBackOnAgencyOverview}></i></h4>}
          <div className='d-flex align-items-center'>
            {userCurrency.currency == 'ALL' ? (
              <div className='form-group currency-select'>
                <i className="fa-solid fa-angle-down drop"></i>
                <select className='form-control' value={currency} onChange={handleCurrency}>
                <option value="INR" >INR </option>
                  <option value="USD" >USD </option>
                <option value="CAD" >CAD </option>
                <option value="EUR" >EUR </option>
                  {/* <option value="BASE"> Base </option> */}
                </select>
              </div>
            ) : (
              <span className='currency-box'>{userCurrency.currency}</span>
            )
            }
            <div className='form-group currency-select'>
              <i className="fa-solid fa-angle-down drop"></i>
              <select className='form-control' onChange={handleDurationType}>
                <option value="daily" > Daily </option>
                <option value="monthly"> Monthly </option>
              </select>
            </div>

            <div className='form-group date-range-block'>
              <i className="fa-solid fa-angle-down drop"></i>
              <input type='text' className='form-control' id="calander_field" value={`${format(applyDateRange.startDate, 'MMM-dd-yyyy')} - ${format(applyDateRange.endDate, 'MMM-dd-yyyy')}`} onClick={handleCalanderToggle} ref={calanderValue} readOnly />
              {toggleCalander && <div className='custom-date-range' ref={isCalanderShow}>
                {durationType == 'monthly' ?
                  <MonthPicker type="range" maxDate={new Date()}
                    numberOfColumns={2} allowSingleDateInRange
                    value={monthRange}
                    onChange={(range) => handleMonthChange(range)}
                  /> :
                  <DateRangePicker ranges={[dateRange]} maxDate={new Date()} onChange={handleDateChange} />
                }
                <button type='button' className={`date-btn ${button.btn} ${button.btnBlue}`} onClick={applyDateFilter}>Apply</button>
              </div>}
            </div>
            {/* <i style={{marginLeft: '10px', fontSize: '25px', marginTop: '5px',color: '#0a58ca',cursor: 'pointer'}} class="fa-solid fa-download"onClick={downloadCSV}></i> */}
            <i style={{ marginLeft: '10px', fontSize: '25px', marginTop: '5px', color: '#0a58ca', cursor: 'pointer' }} class="fa-solid fa-download" onClick={handleHideShowModal}></i>
          </div>
        </div>
        <div className='row'>
          <AgencyPartnersDetail patrners={partnerInfo} SingleGraphData={SingleGraphData} singleGraphList={singleGraphList} graphData={graphData} privillage={privillage} width={cardWidth} patrnerId={handleChildData} currency={currency} />
        </div>
        {/* <Graph /> */}
        <DataListing patrners={partnerInfo} loader={loader} tableData={tableData} onSort={handleSort} sortingColumn={sortingColumn} sortingOrder={sortingOrder} applyDateRange={applyDateRange} currency={currency} />
      </div>

      <div className={`modal form-modal ${showHideModal ? 'show' : ''}`}>
        <div className="modal-dialog modal-md">
          <div className="modal-content">

            <div className="modal-header">
              <h4 className="modal-title">Select partner(s) for download report</h4>
              <i class="fa-regular fa-circle-xmark close-icon" onClick={handleFormReset}></i>
            </div>

            <div className="modal-body">
              {/* <form onSubmit={handleSubmit}> */}
              <div className="form-wraper">
                <div className="form-group custome-select">
                  <label>Agency Partner </label>
                  <Select
                    value={selectedPartner}
                    onChange={handleSelectChange}
                    options={partnerList}
                    defaultValue={partnerList}
                    getOptionLabel={(partnerList) => partnerList.name}
                    getOptionValue={(partnerList) => partnerList.id}
                  />
                </div>
                <div className="form-group custome-select multicheck">
                  <label> Column's</label>
                  <Select
                    placeholder="Select Column's"
                    isClearable="true"
                    isMulti={true}
                    hideSelectedOptions={false}
                    closeMenuOnSelect={false}
                    value={selectedPrivilege}
                    onChange={handlePrivilegeChange}
                    options={privilegeList}
                    components={{ Option: MultiselectCheckbox }}
                    styles={customStyles}
                  />
                </div>

                <div className="form-group custome-select">
                <label>File Format</label>
                <Select
                  value={fileFormat}
                  onChange={setFileFormat}
                  options={[
                    { name: "XLSX", id: "xlsx" },
                    { name: "CSV", id: "csv" }
                  ]}
                  getOptionLabel={(option) => option.name}
                  getOptionValue={(option) => option.id}
                />
              </div>


                <div className="text-end">
                  <button type="button" className={`${button.btn} ${button.btnBlue}`} onClick={downloadCSV}>Download</button>
                </div>
              </div>
              {/* </form> */}
            </div>
          </div>
        </div>
      </div>
      <div className={`${showHideModal ? 'overlay' : ''}`}></div>
    </>
  );
};

export default AgencyOverview;